import { Injectable } from "@angular/core";
import { Observable, map } from "rxjs";

import { BaseHandler } from "@app/core/shared/data/network/base-handler";
import { ApiUrls } from "@app/core/shared/data/network/api-urls";
import {
  HandlerBuilder,
  HttpMethod,
} from "@app/core/shared/data/network/base-handler.parameters";
import { TokenAuthorization } from "@app/core/shared/data/network/token-authorization";
import { MarketingMessage } from "@app/core/marketing/domain/marketing-message";
import { GetNotificationBannerMapper } from "@app/core/notifications/data/network/get-notification-banner.mapper";

@Injectable({
  providedIn: "root",
})
export class GetNotificationBannerWebService {
  constructor(private handler: BaseHandler) {}

  execute(notificationId: number, token: string): Observable<MarketingMessage> {
    const parameters = new HandlerBuilder()
      .setMethod(HttpMethod.get)
      .setUrl(ApiUrls.GET_NOTIFICATION_BANNER_ENDPOINT(notificationId))
      .setAuthorization(new TokenAuthorization(token))
      .build();

    return this.handler
      .execute(parameters)
      .pipe(map(GetNotificationBannerMapper.deserialize));
  }
}
